module.exports = __webpack_public_path__ + "img/9.1de9d240.jpg";